import { NgModule } from '@angular/core';
import { FileUploadModule } from 'ng2-file-upload';
import { SharedModule } from '../shared/shared.module';
import { FileDisplayComponent } from './file-display/file-display.component';
import { FileUploadComponent } from './file-upload/file-upload.component';



@NgModule({
  declarations: [FileUploadComponent, FileDisplayComponent],
  imports: [
    FileUploadModule,
    SharedModule
  ],
  exports : [
    FileUploadComponent
  ]
})
export class FileModule { }
